import { useParams } from 'react-router-dom';

import CreateNewPasswordForm from './components/CreateNewPasswordForm/CreateNewPasswordForm';
import PasswordResetPageHeaderMeta from './components/PasswordResetPageHeaderMeta/PasswordResetPageHeaderMeta';
import { SendPasswordResetEmailForm } from './components/SendPasswordResetEmailForm/SendPasswordResetEmailForm';

const PasswordResetPageContainer = () => {
    // get optional params out of url
    const params = useParams<{ bidderId?: string; hash?: string }>();
    const bidderId: number = params.bidderId ? Number(params.bidderId) : 0;
    const hash: string = params.hash;

    // /password_reset/:bidderId/:hash
    if (bidderId && hash) {
        return (
            <>
                <PasswordResetPageHeaderMeta />
                <CreateNewPasswordForm
                    bidderId={bidderId}
                    hash={hash}
                />
            </>
        );
    }

    // /password_reset
    return (
        <>
            <PasswordResetPageHeaderMeta />
            <SendPasswordResetEmailForm />
        </>
    );
};

export default PasswordResetPageContainer;
